var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"dd47060edaf8f30756989a03d94f824b80e1628a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["exactbuyer@exactbuyer"]={id:"dd47060edaf8f30756989a03d94f824b80e1628a"};
      